import { createFileRoute } from '@tanstack/react-router';
import { CommunicationPage } from '@/features/settings/CommunicationPage';

export const Route = createFileRoute('/app/settings/mailbox')({
  component: CommunicationPage,
  staticData: { title: 'Mailbox · Settings' },
});
